import { Http, HttpRequestConfig, HttpInstance, HttpCancelToken } from '@okapi/http';
import { getIsSuccessStatus } from 'api/helpers/get-is-success-status.helper';

export type TApiRequestConfig = HttpRequestConfig;
export type TApiCancelToken = HttpCancelToken;

export class Api {
  http: HttpInstance;

  constructor() {
    this.http = new Http({
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
      },
    });
  }

  public abortController = () => this.http.abortController();

  post = <Response = unknown, Data extends string | Record<string, string> = Record<string, string>>(
    url: string,
    data: Data,
    config?: TApiRequestConfig
  ) =>
    this._doFetch<Response>(url, {
      method: 'POST',
      data,
      headers: config?.headers,
      ...config,
    });

  get = <Response = unknown, Data extends Record<string, string> = Record<string, string>>(
    url: string,
    data: Data,
    config?: TApiRequestConfig
  ) => {
    const params = new URLSearchParams(data).toString();
    const resultUrl = `${url}?${params}`;
    return this._doFetch<Response>(resultUrl, { method: 'GET', ...config });
  };

  private _doFetch<Response = unknown>(url: string, init: TApiRequestConfig) {
    const resultUrl = /^\/\//.test(url as string) ? `https:${url}` : url;
    return this.http
      .request<Response>(resultUrl, init)
      .then(response => {
        const isSuccessStatus = getIsSuccessStatus(response.status);

        return isSuccessStatus ? response.data : Promise.reject(response);
      })
      .catch(e => Promise.reject(e.response));
  }
}

export const api = new Api();
